/* LUXXS AI Translator landing page. Vanilla JS, no dependencies. */
(() => {
  if (window.LXTR) return;
  const LXTR = (window.LXTR = {});
  document.documentElement.classList.add('lxtr-js');

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    const fmt = format || '${{amount}}';
    const value = (Number(cents) || 0) / 100;
    const withDelims = (n, decimals, thousands, decimal) => {
      const [int, frac] = n.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    }).replace(/\.00(?=\D*$)/, '');
  }

  /* ---------------- Product state ---------------- */
  const dataEl = $('script[data-lxtr-product]');
  const product = dataEl ? JSON.parse(dataEl.textContent) : null;
  const moneyFormat = dataEl?.dataset.moneyFormat;
  const T = {
    en: { save: (n) => `Save ${n}%`, each: (m) => `${m} each`, soldOut: 'Sold out', soldOutNote: 'sold out', addFail: 'Could not add to cart.' },
    es: { save: (n) => `Ahorra ${n}%`, each: (m) => `${m} c/u`, soldOut: 'Agotado', soldOutNote: 'agotado', addFail: 'No se pudo agregar al carrito.' },
  }[dataEl?.dataset.lang === 'es' ? 'es' : 'en'];
  const offersEl = $('script[data-lxtr-offers]');
  const offerCfg = offersEl ? JSON.parse(offersEl.textContent) : { offers: [{ qty: 1, pack: '' }], selected: 0 };

  const colorIndex = product ? product.options.findIndex((o) => /colou?r/i.test(typeof o === 'string' ? o : o.name)) : -1;
  const packIndex = product ? product.options.findIndex((o) => /pack|bundle|set|quantity|quanity/i.test(typeof o === 'string' ? o : o.name)) : -1;

  const state = {
    color: null,
    offer: offerCfg.selected || 0,
  };

  if (product) {
    const initial = product.variants.find((v) => v.id === Number(dataEl.dataset.selected)) || product.variants.find((v) => v.available) || product.variants[0];
    state.color = colorIndex > -1 ? initial.options[colorIndex] : null;
  }

  function variantFor(offerIdx = state.offer, color = state.color) {
    if (!product) return null;
    const offer = offerCfg.offers[offerIdx] || offerCfg.offers[0];
    return product.variants.find((v) => {
      if (colorIndex > -1 && color && v.options[colorIndex] !== color) return false;
      if (packIndex > -1 && offer.pack && v.options[packIndex] !== offer.pack) return false;
      if (packIndex > -1 && !offer.pack && v.options[packIndex] !== product.variants[0].options[packIndex]) return false;
      return true;
    }) || null;
  }

  function quantityFor(offerIdx = state.offer) {
    const offer = offerCfg.offers[offerIdx] || offerCfg.offers[0];
    return packIndex > -1 && offer.pack ? 1 : Math.max(1, Number(offer.qty) || 1);
  }

  function unitsFor(offerIdx = state.offer) {
    const offer = offerCfg.offers[offerIdx] || offerCfg.offers[0];
    return Math.max(1, Number(offer.qty) || 1);
  }

  function priceInfo(offerIdx = state.offer, color = state.color) {
    const v = variantFor(offerIdx, color);
    if (!v) return null;
    const qty = quantityFor(offerIdx);
    const units = unitsFor(offerIdx);
    const now = v.price * qty;
    const was = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price * qty : 0;
    return { v, qty, units, now, was, save: was ? Math.round(((was - now) / was) * 100) : 0, each: Math.round(now / units) };
  }

  function render() {
    if (!product) return;
    const info = priceInfo();
    if (!info) return;
    const { v, now, was, save, each, units } = info;

    $$('[data-lxtr-price-now]').forEach((el) => (el.textContent = formatMoney(now, moneyFormat)));
    $$('[data-lxtr-price-was]').forEach((el) => { el.textContent = was ? formatMoney(was, moneyFormat) : ''; el.hidden = !was; });
    $$('[data-lxtr-price-save]').forEach((el) => { el.textContent = save ? T.save(save) : ''; el.hidden = !save; });
    $$('[data-lxtr-price-each]').forEach((el) => { el.textContent = units > 1 ? T.each(formatMoney(each, moneyFormat)) : ''; el.hidden = units < 2; });

    // Offer cards follow the selected color
    offerCfg.offers.forEach((_, i) => {
      const p = priceInfo(i);
      if (!p) return;
      $$(`[data-lxtr-offer-now="${i}"]`).forEach((el) => (el.textContent = formatMoney(p.now, moneyFormat)));
      $$(`[data-lxtr-offer-was="${i}"]`).forEach((el) => { el.textContent = p.was ? formatMoney(p.was, moneyFormat) : ''; el.hidden = !p.was; });
      $$(`[data-lxtr-offer-each="${i}"]`).forEach((el) => { el.textContent = p.units > 1 ? T.each(formatMoney(p.each, moneyFormat)) : ''; });
    });
    $$('input[data-lxtr-offer]').forEach((el) => (el.checked = Number(el.value) === state.offer));

    // Color controls
    if (colorIndex > -1) {
      $$('input[data-lxtr-color]').forEach((el) => {
        el.checked = el.value === state.color;
        const any = product.variants.some((x) => x.options[colorIndex] === el.value && x.available);
        el.closest('.lxtr-swatch')?.setAttribute('title', any ? el.value : `${el.value} (${T.soldOutNote})`);
      });
      $$('select[data-lxtr-color]').forEach((el) => (el.value = state.color));
      $$('[data-lxtr-color-label]').forEach((el) => (el.textContent = state.color));
    }

    // Availability
    $$('[data-lxtr-add]').forEach((btn) => {
      const label = btn.querySelector('[data-lxtr-label]') || btn;
      if (!btn.dataset.label) btn.dataset.label = label.textContent.trim();
      btn.disabled = !v.available;
      label.textContent = v.available ? btn.dataset.label : T.soldOut;
    });

    // Gallery: first slide tagged with this color, else the variant's own image
    $$('[data-lxtr-gallery]').forEach((g) => {
      const slides = $$('[data-lxtr-slide]', g);
      let target = slides.find((s) => s.dataset.color && s.dataset.color.toLowerCase() === String(state.color).toLowerCase());
      if (!target && v.featured_image) {
        const src = v.featured_image.src || v.featured_image;
        target = slides.find((s) => s.dataset.src && src && src.includes(s.dataset.src));
      }
      if (target) showSlide(g, slides.indexOf(target));
    });

    $$('[data-lxtr-stock]').forEach((el) => {
      const forVariant = el.dataset.variant === String(v.id);
      el.hidden = !forVariant;
    });
  }

  function showSlide(gallery, index) {
    const slides = $$('[data-lxtr-slide]', gallery);
    slides.forEach((s, i) => (s.hidden = i !== index));
    $$('[data-lxtr-thumb]', gallery).forEach((t, i) => t.setAttribute('aria-current', String(i === index)));
  }

  /* ---------------- Events ---------------- */
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches('[data-lxtr-color]')) { state.color = t.value; render(); }
    if (t.matches('input[data-lxtr-offer]')) { state.offer = Number(t.value); render(); }
  });

  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-lxtr-thumb]');
    if (thumb) {
      const g = thumb.closest('[data-lxtr-gallery]');
      showSlide(g, $$('[data-lxtr-thumb]', g).indexOf(thumb));
    }
    const cta = e.target.closest('[data-cta]');
    if (cta) {
      document.dispatchEvent(new CustomEvent('lx:cta-click', { detail: { cta: cta.dataset.cta } }));
      (window.dataLayer = window.dataLayer || []).push({ event: 'lx_cta_click', cta: cta.dataset.cta });
    }
    const add = e.target.closest('[data-lxtr-add]');
    if (add) { e.preventDefault(); addToCart(add); }
  });

  /* ---------------- Cart ---------------- */
  async function addToCart(btn) {
    const info = priceInfo();
    if (!info || !info.v.available) return;
    const msg = btn.closest('[data-lxtr-buy]')?.querySelector('[data-lxtr-msg]');
    if (msg) { msg.textContent = ''; msg.removeAttribute('data-type'); }
    btn.dataset.state = 'loading';
    btn.setAttribute('aria-busy', 'true');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: info.v.id, quantity: info.qty }] }),
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.description || body.message || T.addFail);
      const cart = await (await fetch(`${root}cart.js`)).json();

      const detail = { cta: btn.dataset.cta, variant_id: info.v.id, quantity: info.qty, value: info.now / 100, currency: cart.currency };
      document.dispatchEvent(new CustomEvent('lx:add-to-cart', { detail }));
      (window.dataLayer = window.dataLayer || []).push({ event: 'lx_add_to_cart', ...detail });

      const drawer = document.querySelector('cart-drawer-component');
      // Tell the theme the cart changed: refreshes the cart count and drawer contents (and auto-opens it if enabled).
      const evt = new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'lxtr', data: { source: 'lxtr', itemCount: cart.item_count, variantId: String(info.v.id), productId: String(product.id) } } });
      document.dispatchEvent(evt);
      if (drawer) {
        if (!drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
      } else {
        window.location.href = `${root}cart`;
      }
    } catch (err) {
      if (msg) { msg.textContent = err.message; msg.dataset.type = 'error'; }
    } finally {
      delete btn.dataset.state;
      btn.removeAttribute('aria-busy');
    }
  }

  /* ---------------- Accordions ---------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.lxtr-acc__btn');
    if (!btn) return;
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    const open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    if (panel) panel.hidden = open;
  });

  /* ---------------- Tabs ---------------- */
  function selectTab(tab, focus) {
    const list = tab.closest('[role="tablist"]');
    $$('[role="tab"]', list).forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus();
  }
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.lxtr [role="tab"]');
    if (tab) selectTab(tab);
  });
  document.addEventListener('keydown', (e) => {
    const tab = e.target.closest('.lxtr [role="tab"]');
    if (!tab) return;
    const tabs = $$('[role="tab"]', tab.closest('[role="tablist"]'));
    const i = tabs.indexOf(tab);
    const map = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 };
    if (!(e.key in map)) return;
    e.preventDefault();
    selectTab(tabs[(map[e.key] + tabs.length) % tabs.length], true);
  });

  /* ---------------- Reveal on scroll ---------------- */
  const reveals = $$('[data-lxtr-reveal]');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((el) => el.classList.add('is-in'));
  } else {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  }

  /* ---------------- Sticky bar ---------------- */
  const sticky = $('[data-lxtr-sticky]');
  if (sticky) {
    document.body.appendChild(sticky);
    const anchors = $$('[data-lxtr-sticky-anchor]');
    const blockers = $$('[data-lxtr-sticky-hide]');
    const seen = new Map();
    const update = () => {
      const anchorsAbove = anchors.length && anchors.every((a) => { const r = a.getBoundingClientRect(); return r.bottom < 0; });
      const blocked = blockers.some((b) => seen.get(b));
      const show = anchors.length ? anchorsAbove && !blocked : window.scrollY > 600 && !blocked;
      sticky.dataset.visible = String(show);
      sticky.inert = !show;
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => { entries.forEach((en) => seen.set(en.target, en.isIntersecting)); update(); });
      [...anchors, ...blockers].forEach((el) => io.observe(el));
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------------- Countdown (fixed end date, never resets) ---------------- */
  $$('[data-lxtr-countdown]').forEach((el) => {
    const end = new Date(el.dataset.end).getTime();
    const out = el.querySelector('time');
    if (!end || Number.isNaN(end)) { el.hidden = true; return; }
    const tick = () => {
      const ms = end - Date.now();
      if (ms <= 0) { el.hidden = true; return clearInterval(timer); }
      const d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
      out.textContent = `${d ? d + 'd ' : ''}${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      el.hidden = false;
    };
    const timer = setInterval(tick, 1000);
    tick();
  });

  render();
  LXTR.state = state;
  LXTR.render = render;
})();
